"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iFile = exports.iProject = exports.iCongridProject = exports.iMeta = void 0;
const t = require("io-ts");
const file_1 = require("./file");
exports.iMeta = t.interface({
    id: t.string,
    name: t.string
});
exports.iCongridProject = t.interface({
    name: t.string,
    congridId: t.string
});
exports.iProject = t.intersection([
    exports.iCongridProject,
    t.interface({
        id: t.number,
        uuid: t.string,
        project: t.number,
        projectUuid: t.string,
        key: t.string
    })
]);
exports.iFile = t.intersection([
    file_1.iRevision,
    t.interface({
        congrid: t.interface({
            id: t.union([t.string, t.null]),
            projectId: t.string,
            floorPlanTypeId: t.string,
            slug: t.union([t.string, t.null])
        })
    })
]);
//# sourceMappingURL=congrid.js.map